// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import styles from './ProgressRing.module.css';

/** Circumference of the r = 7.5 ring, in viewBox units. */
const RING = 2 * Math.PI * 7.5;

/**
 * "3 af 8 godkendt" with a ring that fills as types are approved. In the top
 * bar the words drop on a phone; `keepText` keeps them (Sager's cards, where
 * nothing else says it).
 */
export function ProgressRing({ approved, total, keepText = false }: { approved: number; total: number; keepText?: boolean }) {
  const share = total > 0 ? Math.min(1, Math.max(0, approved / total)) : 0;
  const text = `${approved} af ${total} godkendt`;
  return (
    <span className={keepText ? `${styles.wrap} ${styles.keepText}` : styles.wrap} title={text}>
      <svg className={styles.ring} viewBox="0 0 20 20" aria-hidden="true">
        <circle className={styles.track} cx="10" cy="10" r="7.5" />
        <circle
          className={styles.fill}
          cx="10"
          cy="10"
          r="7.5"
          strokeDasharray={`${(RING * share).toFixed(2)} ${RING.toFixed(2)}`}
          transform="rotate(-90 10 10)"
        />
      </svg>
      <span className={styles.text}>{text}</span>
    </span>
  );
}
